/**
 * Binance API for historical OHLC data
 */

const BINANCE_API = 'https://api.binance.com/api/v3'

const SYMBOLS: Record<string, string> = {
  BTC: 'BTCUSDT',
  ETH: 'ETHUSDT',
  SOL: 'SOLUSDT',
}

export interface Kline {
  time: number
  open: number
  high: number
  low: number
  close: number
}

export async function fetchKlines(
  crypto: string,
  interval: string = '1h',
  limit: number = 72
): Promise<Kline[]> {
  const symbol = SYMBOLS[crypto] ?? 'BTCUSDT'
  const res = await fetch(
    `${BINANCE_API}/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`
  )
  if (!res.ok) throw new Error(`Binance API: ${res.status}`)
  const raw = (await res.json()) as Array<[number, string, string, string, string, ...unknown[]]>
  return raw.map(([openTime, o, h, l, c]) => ({
    time: Math.floor(openTime / 1000),
    open: parseFloat(o),
    high: parseFloat(h),
    low: parseFloat(l),
    close: parseFloat(c),
  }))
}
